import React, { useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useAccess } from 'contexts/access'
import { useWorkSchedules } from 'contexts/work-schedules'
import { useOrganization } from 'contexts/organization'
import { useLocationStateIntent } from 'hooks/location-intent'
import { useNavigate } from 'react-router-dom'
import paths from 'app/paths'
import { HeroColumns, TitleColumns, ActionColumn } from './s'
import ModuleTitle from 'components/module-title'
import { Ghost, ButtonArrow } from 'components/button'
import ExportAbsence from 'pages/absence/modals/export'
import UpgradeModal from 'modals/upgrade'
import AbsencePanel from 'pages/absence/panel'
import Message from 'components/message'

const AbsenceHero = ({ upgradable, salt }) => {
    const { formatMessage } = useIntl()

    const [upgrading, setUpgrading] = useState(false)

    const { check } = useAccess()
    const absenceAdmin = check('absence:manage')
    const manageAccess = check('user:absence:manage')

    const { statuses } = useOrganization()

    const {
        schedules,
        hasFetched
    } = useWorkSchedules()

    const navigate = useNavigate()
    const setup = () => navigate(paths.absence.setup)

    useLocationStateIntent({
        intent: 'setup',
        action: setup,
        requirements: [absenceAdmin]
    })

    return (
        <>
            <HeroColumns>
                <ModuleTitle which="absence" />
                {(absenceAdmin || manageAccess || upgradable) && (
                    <TitleColumns>
                        {!upgradable && <AbsencePanel salt={salt} />}
                        {((absenceAdmin || upgradable) && !statuses?.hasSetUpAbsenceTypes && !statuses?.hasSetUpWorkSchedule) && (
                            <ActionColumn>
                                <Ghost
                                    onClick={setup}
                                    className="constructive"
                                    disabled={upgrading}
                                    {...(upgradable ? {
                                        upgradable: true,
                                        onClick: () => setUpgrading(true)
                                    } : null)}>
                                    <FormattedMessage
                                        id="absence_action_set_up"
                                        defaultMessage="Set up absence" />
                                </Ghost>
                                {!upgradable && <ButtonArrow />}
                            </ActionColumn>
                        )}
                        {(absenceAdmin && !upgradable && !!statuses?.hasSetUpWorkSchedule && hasFetched) && (
                            <div>
                                <ExportAbsence salt={salt} />
                            </div>
                        )}
                    </TitleColumns>
                )}
            </HeroColumns>
            {(!absenceAdmin && !schedules?.length && hasFetched && !upgradable) && (
                <Message
                    type="info"
                    message={formatMessage({
                        id: 'absence_message_not_activated',
                        defaultMessage: 'This module is not activated. Ask your administrator to activate it and set it up before you can register your absence.'
                    })} />
            )}
            {upgradable && (
                <UpgradeModal
                    heading={formatMessage({
                        id: 'absence_action_set_up',
                        defaultMessage: 'Set up absence'
                    })}
                    dismiss={() => setUpgrading(false)}
                    {...(upgrading ? {
                        upgrade: { module: 'absence' }
                    } : null)}
                    callback={setup}
                    salt={`${salt}:upgrade`}>
                </UpgradeModal>
            )}
        </>
    )
}

export default AbsenceHero
